



























































import { CaseWithMessages } from '@/queries/cases.graphql'
import DatePicker from '@/components/workflow/Datepicker.vue'
import { MyInterviewOffers } from './ResetAppointment.graphql'
import moment from 'moment'

export default {
  computed: {
    options() {
      return this.offers.nodes
        .filter(offer => offer.activeBookings.nodes.length === 0)
        .map(offer => ({
          value: offer.id,
          text: `${moment(offer.timeSlot.start.value).format('YYYY-MM-DD HH:mm')} til ${moment(
            offer.timeSlot.end.value
          ).format('YYYY-MM-DD HH:mm')}`,
        }))
    },
    patientAlias() {
      const thisCase = this.pickedCase
      if (thisCase) {
        return thisCase.patient.alias
      } else {
        return 'error unknown case'
      }
    },
  },
  apollo: {
    offers: {
      query: MyInterviewOffers,
      variables() {
        return {
          interviewerId: this.$store.getters.currentUserId,
        }
      },
    },
    pickedCase: {
      query: CaseWithMessages,
      variables() {
        return {
          id: this.caseId,
        }
      },
    },
  },
  components: {
    DatePicker,
  },
  data() {
    return {
      newDate: this.value.newDate || '',
      abandon: this.value.abandon || false,
      useOfferId: this.value.useOfferId || null,
      externalLink: this.value.externalLink || '',
      offers: { nodes: [] },
    }
  },
  props: {
    caseId: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: Object,
    },
  },
  methods: {
    confirm() {
      return window.confirm('Are you sure?')
    },
    emit() {
      this.$emit('input', {
        newDate: this.newDate,
        abandon: this.abandon,
        useOfferId: this.useOfferId,
        isPost: true,
        externalLink: this.externalLink,
      })
    },
    validate() {
      const valid = !!this.abandon || !!this.useOfferId || (this.newDate && this.newDate != '')
      if (!valid) {
        window.alert('Enter a date or choose an existing appointment')
        return false
      }
      return valid
    },
  },
  watch: {
    useOfferId(newOfferId, oldOfferId) {
      if (newOfferId) {
        this.offers.nodes
          .filter(offer => offer.id === newOfferId)
          .forEach(offer => (this.externalLink = offer.externalLink || this.externalLink))
      }
    },
  },
}
